export enum PreLiquidationStep {
    ONE = 0,
    THREE = 2,
    TWO = 1,
  }
  